import { Injectable } from '@angular/core';

@Injectable()
export class RememberMeService {

  private credentials: {
    '__email__': string,
    '__password__': string
  };

  constructor() { }

  setCredentials (emailAndPassword) {
    this.credentials = emailAndPassword;
  }

  getCredentials () {
    return this.credentials;
  }

}



// WEBPACK FOOTER //
// /var/www/asna/front-end/public_html/src/app/service/remember-me.service.ts